import React, { useRef, useState } from 'react';

// Generic drag-and-drop / click-to-browse area. Calls onFiles(File[]) with the accepted files.
// accept: list of lowercase extensions, e.g. ['.csv'].
export default function FileDrop({ accept, multiple = false, title, hint, onFiles, children }) {
  const inputRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [rejected, setRejected] = useState(null);

  const handle = (fileList) => {
    const files = Array.from(fileList || []);
    const ok = files.filter((f) => accept.some((ext) => f.name.toLowerCase().endsWith(ext)));
    setRejected(ok.length < files.length ? `Ignored ${files.length - ok.length} file(s) that are not ${accept.join(' / ')}` : null);
    if (ok.length > 0) onFiles(multiple ? ok : ok.slice(0, 1));
  };

  return (
    <div>
      <div
        className={`rec-dropzone rec-dropzone-tall${dragging ? ' rec-dropzone-active' : ''}`}
        role="button"
        tabIndex={0}
        onClick={() => inputRef.current && inputRef.current.click()}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            inputRef.current && inputRef.current.click();
          }
        }}
        onDragOver={(e) => {
          e.preventDefault();
          setDragging(true);
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(e) => {
          e.preventDefault();
          setDragging(false);
          handle(e.dataTransfer.files);
        }}
      >
        <div className="rec-dropzone-hint">
          <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5} aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 16.5V3m0 0L7.5 7.5M12 3l4.5 4.5M3.75 16.5v2.25A1.5 1.5 0 0 0 5.25 20.25h13.5a1.5 1.5 0 0 0 1.5-1.5V16.5" />
          </svg>
          <strong className="rec-dropzone-title">{title}</strong>
          {hint && <span>{hint}</span>}
          {children}
        </div>
        <input
          ref={inputRef}
          type="file"
          accept={accept.join(',')}
          multiple={multiple}
          hidden
          onChange={(e) => {
            handle(e.target.files);
            e.target.value = '';
          }}
        />
      </div>
      {rejected && <p className="rec-error rec-sm rec-drop-note">{rejected}</p>}
    </div>
  );
}
